import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TasksVO, DateUtility, Task, WpProviderReport, REPSTDT_GT_REPENDDT, ServerConstantsService } from '../shared';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { GridOptions } from "ag-grid/main";
import { Subscription } from 'rxjs/Subscription';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import * as zingchart from 'zingchart';
import { CommonUtility, DataService, DOUBLE_ROW_HEADER,OVERDUE_BTN,WpPerson,WpReferral,TaskSearch } from '../shared/';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class ReportSummaryComponent implements OnInit {
  // Column Defs
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER
  context: any;
  private gridOptions: GridOptions;
  gridApi: any;
  referralId:any;
  gridApiProgress: any;
  gridApiOpen: any;
  countyDisabled: boolean = false;
  gridApiPending: any;
  countyId: any;
  butDisabled: boolean = false;
  tasksColumnDefs: any;
  inProgressColumnDefs: any;
  openTasksColumnDefs: any;
  pendingTasksColumnDefs: any;
  area1 = ["Benton","Carroll","Boone","Marion","Baxter","Fayetteville","Washington 1","Washington 2","Newton","Searcy","Crawford","Franklin","Logan 1","Logan 2","Scott","Polk","Sebastian"].sort();
  area2 = ["Fulton","Izard","Randolph","Clay","Sharp","Lawrence","Greene","Jackson","Craighead","Mississippi 1","Mississippi 2","Poinsett","Cross","Crittenden","Independence"].sort();
  area3 = ["Johnson","Pope","Yell","Perry","Conway","Van Buren","Faulkner","Stone","Cleburne","White","Lonoke","Prairie","Woodruff"].sort();
  area4 = ["Sevier","Little River","Miller","Lafayette","Hempstead","Pike","Montgomery","Columbia","Nevada","Clark","Hot Spring","Garland","Saline 1","Saline 2","Dallas","Ouachita","Calhoun","Union"].sort();
  area5 = ["Grant","Jefferson 1","Jefferson 2","Cleveland","Bradley","Lincoln","Drew","Ashley","Arkansas A","Arkansas B","Desha","Chicot","Monroe 1","Monroe 2","Phillips","Lee"].sort();
  area6 = ["Pulaski - East","Pulaski - Jacksonville","Pulaski - North","Pulaski - South","Pulaski - Southwest", "Central Office"].sort();
  allArea = ["Benton", "Carroll", "Boone", "Marion", "Baxter", "Fayetteville", "Washington 1", "Washington 2", "Newton", "Searcy", "Crawford", "Franklin", "Logan 1", "Logan 2", "Scott", "Polk", "Sebastian", "Fulton", "Izard", "Randolph", "Clay", "Sharp", "Lawrence", "Greene", "Jackson", "Craighead", "Mississippi 1", "Mississippi 2", "Poinsett", "Cross", "Crittenden", "Independence",
    "Johnson", "Pope", "Yell", "Perry", "Conway", "Van Buren", "Faulkner", "Stone", "Cleburne", "White", "Lonoke", "Prairie", "Woodruff", "Sevier", "Little River", "Miller", "Lafayette", "Hempstead", "Pike", "Montgomery", "Columbia", "Nevada", "Clark", "Hot Spring", "Garland", "Saline 1", "Saline 2", "Dallas", "Ouachita", "Calhoun", "Union",
    "Grant", "Jefferson", "Cleveland", "Bradley", "Lincoln", "Drew", "Ashley", "Arkansas A", "Arkansas B", "Desha", "Chicot","Monroe 1","Monroe 2", "Phillips", "Lee", "Pulaski - East","Pulaski - Jacksonville","Pulaski - North","Pulaski - South","Pulaski - Southwest", "Central Office"].sort();
  title = 'app';
  roleId: number;
  sharedData: any;
  taskDueDateFrom: any;
  employees = [
    {"firstName": "John", "lastName": "Doe"},
    {"firstName": "Anna", "lastName": "Smith"},
    {"firstName": "Peter", "lastName": "Jones"}
  ];
  tabToNextCell: any;
  countyArray: string[] = [];
  tasksVO: TasksVO;
  inputTasksVO: TasksVO;
  tasks: Task[]=[];
  areaCode: any;
  pendingTasks: Task[];
  openTasks: Task[];
  inProgressTasks: Task[];
  pdfFlag = 'all';
  reportBeginDate: any;
  taskTypeList: string[];
  errorEndDateField: any;
  reportEndDate: any;
  tasktype: any;
  selectedGrid = 'all';
  overDue:any=[];

  county: any;
  provider: any;
  WpProviders: WpProviderReport[];
  countyList: string[];
  ServerConstants: any;
  userActionNotificationsMap: any;
  @ViewChild('content4') content4: ElementRef;
  @ViewChild('content5') content5: ElementRef;
  @ViewChild('all1') all1: ElementRef;
  @ViewChild('pending1') pending1: ElementRef;
  @ViewChild('content6') content6: ElementRef;
  @ViewChild('content7') content7: ElementRef;
  @ViewChild('open1') open1: ElementRef;
  @ViewChild('INP1') INP1: ElementRef;
  @ViewChild('content') content: ElementRef;
  @ViewChild('content1') content1: ElementRef;
  @ViewChild('all') all: ElementRef;
  @ViewChild('pending') pending: ElementRef;
  @ViewChild('content2') content2: ElementRef;
  @ViewChild('content3') content3: ElementRef;
  @ViewChild('open') open: ElementRef;
  @ViewChild('INP') INP: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  firstTime: Boolean = true;
  ws: any;
  gridSelected: any = 'all';

  downloadnodePDF() {
    var width = 420;
    var height = 220;
    var temp = [420, 220];
    var doc = new jsPDF("p", "mm", "a1");

    let specialElementHandlers = {
      '#editor': function (element, renderer) {
        return true;
      }
    };
    let content = this.all1.nativeElement;
    let content1 = this.content4.nativeElement;
    let content2 = this.pending1.nativeElement;
    let content3 = this.content5.nativeElement;
    let content4 = this.INP1.nativeElement;
    let content5 = this.content6.nativeElement;
    let content6 = this.open1.nativeElement;
    let content7 = this.content7.nativeElement;
    let content8 = this.all.nativeElement;
    let content9 = this.content.nativeElement;
    let content10 = this.pending.nativeElement;
    let content11 = this.content1.nativeElement;
    let content12 = this.INP.nativeElement;
    let content13 = this.content2.nativeElement;
    let content14 = this.open.nativeElement;
    let content15 = this.content3.nativeElement;
    doc.text('TASK SUMMARY', 20, 25);
    if (content8.offsetParent == null && content10.offsetParent == null && content12.offsetParent == null) {
      doc.fromHTML(content7.innerHTML, 20, 20, {
        'width': 200,
        'height': "50%",
        'elementHandlers': specialElementHandlers
      });
    }
    if (content8.offsetParent == null && content10.offsetParent == null && content14.offsetParent == null) {
      doc.fromHTML(content5.innerHTML, 20, 20, {
        'width': 200,
        'height': "50%",
        'elementHandlers': specialElementHandlers
      });
    }
    if (content8.offsetParent == null && content12.offsetParent == null && content14.offsetParent == null) {
      doc.fromHTML(content3.innerHTML, 20, 20, {
        'width': 200,
        'height': "50%",
        'elementHandlers': specialElementHandlers
      });
    }
    if (content10.offsetParent == null && content12.offsetParent == null && content14.offsetParent == null) {
      doc.fromHTML(content1.innerHTML, 20, 20, {
        'width': 200,
        'height': "50%",
        'elementHandlers': specialElementHandlers
      });
    }
    doc.save('test.pdf');
  }

  downloadExcelKeydown(event) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      this.downloadExcel(event);
    }
  }

  downloadPDFJsonKeydown(event) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      this.downloadPDFJson(event);
    }
  }

  downloadPDFJson(event) {
    var doc = new jsPDF("p", "mm", "a1");
    let content = this.all1.nativeElement;
    let content1 = this.content4.nativeElement;
    let content2 = this.pending1.nativeElement;
    let content3 = this.content5.nativeElement;
    let content4 = this.INP1.nativeElement;
    let content5 = this.content6.nativeElement;
    let content6 = this.open1.nativeElement;
    let content7 = this.content7.nativeElement;
    let content8 = this.all.nativeElement;
    let content9 = this.content.nativeElement;
    let content10 = this.pending.nativeElement;
    let content11 = this.content1.nativeElement;
    let content12 = this.INP.nativeElement;
    let content13 = this.content2.nativeElement;
    let content14 = this.open.nativeElement;
    let content15 = this.content3.nativeElement;
    doc.text('TASK SUMMARY', 20, 25);
    var col = ["Task Type", "Client Name", "Task Creation Date", "Task Due Date", "Service County", "Task Completion Date", "Task Status", "Assigned To"];
    var rows = [];
    if (content8.offsetParent == null && content10.offsetParent == null && content12.offsetParent == null) {
      var rowCountModNew = this.openTasks;
    }
    if (content8.offsetParent == null && content10.offsetParent == null && content14.offsetParent == null) {
      var rowCountModNew = this.inProgressTasks;
    }
    if (content8.offsetParent == null && content12.offsetParent == null && content14.offsetParent == null) {
      var rowCountModNew = this.pendingTasks;
    }
    if (content10.offsetParent == null && content12.offsetParent == null && content14.offsetParent == null) {
      var rowCountModNew = this.tasks;
    }
    rowCountModNew.forEach(element => {
      console.log("element data is " + element);
      var row = [element.taskType, element.assignedTo, element.taskStartDt, element.taskDueDt, element.programCd, element.taskCompletionDt, element.taskStatus, element.assignedUserStr];
      rows.push(row);

    });

    doc.text('Task List', 13, 10); 
    doc.autoTable(col, rows);
    doc.save('TaskStatusSummary.pdf');
  }

  downloadExcel(event) {
    // let content = this.all.nativeElement;
    // let content1 = this.content.nativeElement;
    // let content2 = this.pending.nativeElement;
    // let content3 = this.content1.nativeElement;
    // let content4 = this.INP.nativeElement;
    // let content5 = this.content2.nativeElement;
    // let content6 = this.open.nativeElement;
    // let content7 = this.content3.nativeElement;
    let content = this.all1.nativeElement;
    let content1 = this.content4.nativeElement;
    let content2 = this.pending1.nativeElement;
    let content3 = this.content5.nativeElement;
    let content4 = this.INP1.nativeElement;
    let content5 = this.content6.nativeElement;
    let content6 = this.open1.nativeElement;
    let content7 = this.content7.nativeElement;
    let content8 = this.all.nativeElement;
    let content9 = this.content.nativeElement;
    let content10 = this.pending.nativeElement;
    let content11 = this.content1.nativeElement;
    let content12 = this.INP.nativeElement;
    let content13 = this.content2.nativeElement;
    let content14 = this.open.nativeElement;
    let content15 = this.content3.nativeElement;
    const ws_name = 'Task List';
    const wb: WorkBook = {SheetNames: [], Sheets: {}};

    if (content8.offsetParent == null && content10.offsetParent == null && content12.offsetParent == null) {
      this.ws = utils.table_to_sheet(content6);

    }
    if (content8.offsetParent == null && content10.offsetParent == null && content14.offsetParent == null) {
      this.ws = utils.table_to_sheet(content4);
    }
    if (content8.offsetParent == null && content12.offsetParent == null && content14.offsetParent == null) {
      this.ws = utils.table_to_sheet(content2);
    }
    if (content10.offsetParent == null && content12.offsetParent == null && content14.offsetParent == null) {
      this.ws = utils.table_to_sheet(content);
    }
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = this.ws;
    const wbout = write(wb, {bookType: 'xlsx', bookSST: true, type: 'binary'});

    function s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
      }
      ;
      return buf;
    }

    saveAs(new Blob([s2ab(wbout)], {type: 'application/octet-stream'}), 'TaskStatusSummary.xlsx');
  }

  loadCounty(params) {
    this.areaCode = params;
    if (this.areaCode == "Area I") {
      this.countyList = this.area1;
    }
    else if (this.areaCode == "Area II") {
      this.countyList = this.area2;
    }
    else if (this.areaCode == "Area III") {
      this.countyList = this.area3;
    }
    else if (this.areaCode == "Area IV") {
      this.countyList = this.area4;
    }
    else if (this.areaCode == "Area V") {
      this.countyList = this.area5;
    }
    else if (this.areaCode == "Area VI") {
      this.countyList = this.area6;
    }
    else {
      this.countyList = this.allArea;
    }
  }

  resetPDF() {
        if (this.dataService.getSharedDataObject().get("RPRDE").navigation === false && this.dataService.getSharedDataObject().get("RPRDO").navigation === false) {
      this.router.navigate(['/reports/federalReports']);
    }
    this.overDue = [];
    this.inputTasksVO = new TasksVO();
    if (this.reportBeginDate != null) {
      let day = this.reportBeginDate.day;
      let month = this.reportBeginDate.month;
      let year = this.reportBeginDate.year;
      if (day < 10 && month < 10) {
        this.reportBeginDate = year + '/0' + month + '/0' + day;
      }
      if (day < 10) {
        this.reportBeginDate = year + '/' + month + '/0' + day;
      }
      if (month < 10) {
        this.reportBeginDate = year + '/0' + month + '/' + day;
      }
      else {
        this.reportBeginDate = year + '/' + month + '/' + day;
      }
      console.log(this.reportBeginDate);
    }

    if (this.reportEndDate != null) {
      let day = this.reportEndDate.day;
      let month = this.reportEndDate.month;
      let year = this.reportEndDate.year;
      this.reportEndDate = year + '/' + month + '/' + day;

      if (day < 10 && month < 10) {
        this.reportEndDate = year + '/0' + month + '/0' + day;
      }
      if (day < 10) {
        this.reportEndDate = year + '/' + month + '/0' + day;
      }
      if (month < 10) {
        this.reportEndDate = year + '/0' + month + '/' + day;
      }
      else {
        this.reportEndDate = year + '/' + month + '/' + day;
      }
    }
    this.inputTasksVO.provider = "All";
    this.inputTasksVO.county = "All";
    this.inputTasksVO.taskType = "All";
    this.inputTasksVO.areaCode = "All";
    this.inputTasksVO.reportBeginDate = "default";
    this.inputTasksVO.reportEndDate = "default";
    this.sharedData = this.dataService.getSharedDataObject();
    this.roleId = this.sharedData.get("roles")[0].id;

    if (this.sharedData.get("roles")[0].id == 5) {
      this.butDisabled = true;
      console.log("counties : " + this.sharedData.get("userCounties").length);
      for (let i = 0; i < this.sharedData.get("userCounties").length; i++) {
        this.countyArray[i] = this.sharedData.get("userCounties")[i].id.serviceCounty;
        this.inputTasksVO.user = "provider";
        console.log("county id is : " + this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
      }
      this.inputTasksVO.countyArray = this.countyArray;
      this.inputTasksVO.providerId = this.sharedData.get("providerId");
    }
    else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
    {
    this.butDisabled = true;
    this.countyDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    console.log("county id is : "+this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
     }
    this.inputTasksVO.user = "countyWorker";
    this.inputTasksVO.countyArray=this.countyArray;
    this.inputTasksVO.county=this.countyArray[0];
    this.inputTasksVO.provider=null;
    this.inputTasksVO.areaCode=null;
    }
    else if(this.sharedData.get("roles")[0].id == 2)
    {
    this.butDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyId=this.sharedData.get("userCounties")[i].id.serviceCounty;
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    }
    this.inputTasksVO.countyArray=this.countyArray;
    this.inputTasksVO.user="areaSupervisor";
    this.inputTasksVO.county="All"
    this.inputTasksVO.areaCode = null;
    this.inputTasksVO.provider = null;
    }
    else {
      this.inputTasksVO.areaCode = "All";
      this.inputTasksVO.user = "countyUser";
    }
    //Retrieve reference tables
    this.refTableService.currentMessage.subscribe((message) => {
      //Parse reference table data
      if (message && message.englishDropDown) {
        this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(message.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
      }

      //Call load
      this.load();
    });
    this.getTasksColumnDefs();
    /* this.getInProgressColumnDefs();
     this.getOpenTasksColumnDefs();
     this.getPendingTasksColumnDefs();*/
    //document.getElementById("all").removeAttribute("hidden");
    //document.getElementById("pending").setAttribute("hidden", "true");
    //document.getElementById("INP").setAttribute("hidden", "true");
    //document.getElementById("open").setAttribute("hidden", "true");
    //this.firstTime = true;
    //this.load();
  }

  goReportSummary() {
    this.router.navigate(['/reports/report-summary']);
  }

  chartData = {
    "graphset": [
      {
        "type": "ring",
        "legend": {
          "draggable": true,
          "visible": "false",
          "x": "65%",
          "y": "10%"
        },
        "title": {
          "text": "Task Status Summary",
          "font-size": 14,
          "text-align": "center"
        },
        noData: {
          text: "THERE IS NO DATA TO DISPLAY",
          fontSize: 18,
          textAlpha: .9,
          alpha: .6,
          bold: true
        },
        "plot": {
          slice: '75%',
          "value-box": {
            "placement": "out",
            decimals: 1,
            "font-size": 8,
            "offset-r": "20%"
          },
          "tooltip": {
            "text": " %t"
          }
        },
        "series": [{
          values: []
        }]
      }

    ]
  };

  chartData2 = {
    "graphset": [
      {
        "type": "ring",
        "title": {
          "text": "Task Type Summary",
          "font-size": 14,
          "text-align": "center"
        },
        "legend": {
          "draggable": true,
          "visible": "false",
          "max-items": 4,
          "layout": "4x1",
          "overflow": "page",
          "page-on": {
            "background-color": "red",
            "border-width": 1,
            "border-color": "red"
          },
          "page-off": {
            "background-color": "#ffe6e6",
            "border-width": 1,
            "border-color": "red"
          },
          "page-status": {
            "font-color": "red",
            "font-size": 8,
            "font-family": "Georgia",
            "background-color": "#ffe6e6",
          },
          "x": "75%",
          "y": "10%"
        },
        noData: {
          text: "THERE IS NO DATA TO DISPLAY",
          fontSize: 18,
          textAlpha: .9,
          alpha: .6,
          bold: true
        },
        "plot": {
          slice: '75%',
          "value-box": {
            "placement": "out",
            decimals: 1,
            "font-size": 8,
            "offset-r": "20%"
          },
          "tooltip": {
            "text": " %t"
          }
        },
        "series": [{
          values: []
        }]
      }
    ]
  };

  load() {
    setTimeout(()=>{
    var value: any[] = [];
    this.http.post<TasksVO>(this.ServerConstants.REPORT_SERVER_API_URL + '/reportTaskSummary/load', this.inputTasksVO).subscribe(
      (data: TasksVO) => {
        this.tasks=[];
        this.openTasks = [];
        this.inProgressTasks = [];
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        data.opentasksList.forEach((element)=>{
          if(new Date(element.taskDueDt) < today){
            this.overDue.push(element);
          }
          else{
            this.openTasks.push(element);
          }
        })
        data.inProgresstasksList.forEach((element)=>{
          if(new Date(element.taskDueDt) < today){
            this.overDue.push(element);
          }
          else{
            this.inProgressTasks.push(element);
          }
        })
        if (data.seriesInfoList !== null) {
          data.seriesInfoList.push({values:[0],text:"OVERDUE"});
          data.seriesInfoList.forEach((element)=>{
            if(element.text === "IN PROGRESS"){
              element.values[0] = (this.inProgressTasks.length/ data.tasksList.length)*100; 
            }
            else if(element.text === "OPEN"){
              element.values[0] = (this.openTasks.length/ data.tasksList.length)*100; 
            }
            else if(element.text === "OVERDUE"){
              element.values[0] = ( this.overDue.length/ data.tasksList.length)*100; 
            }
            else{
              element = element;
            }
          })
        }
        
        //this.overDue = data.tasksList
        // convert date to the proper format for UI
        if (data.seriesInfoList == null) {
          this.chartData.graphset[0].series = data.seriesInfoList;
          this.chartData.graphset[0].legend.visible = "false";
        }
        else {
          //data.seriesInfoList.push({text:'OverDue',values:[73.2]});
          this.chartData.graphset[0].series = data.seriesInfoList;
          this.chartData.graphset[0].legend.visible = "true";
        }
        let serialData2=[];
        let valued=[];
        for (let i=0;i<data.taskTypeList.length;i++){
          let count =0;
          valued=[];
          for(let j=0;j<data.tasksList.length;j++){
            if(data.taskTypeList[i] == data.tasksList[j].taskType.replace(/(\r\n|\n|\r)/gm, " ")){
                count+=1;
            }
          }
          valued.push(count);
          serialData2.push({"text":data.taskTypeList[i],"values":valued});
        }
        if (data.seriesInfoList2 == null) {
          this.chartData2.graphset[0].series = serialData2;
          this.chartData2.graphset[0].legend.visible = "false";
        }
        else {
          this.chartData2.graphset[0].series = serialData2;
          this.chartData2.graphset[0].legend.visible = "true";
        }
        this.tasksVO = data;
        this.tasks = this.tasksVO.tasksList;
        this.reportBeginDate = this.tasksVO.reportBeginDate;
        this.reportEndDate = this.tasksVO.reportEndDate;
        this.pendingTasks = this.tasksVO.pendingtasksList;
        this.areaCode = this.tasksVO.areaCode;
        this.provider = this.tasksVO.provider;
        //this.county = this.tasksVO.county;
        this.tasktype = this.tasksVO.taskType;
        if (this.tasksVO.reportBeginDate != null) {
          this.reportBeginDate = this.dateUtil.convertDateFromServerForreports(this.tasksVO.reportBeginDate);
          console.log("date after is " + this.reportBeginDate);
        }

        if (this.tasksVO.reportEndDate != null) {
          this.reportEndDate = this.dateUtil.convertDateFromServerForreports(this.tasksVO.reportEndDate);
        }
        //this.openTasks = this.tasksVO.opentasksList;
        this.taskTypeList = this.tasksVO.taskTypeList;
        //this.inProgressTasks = this.tasksVO.inProgresstasksList;
         if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3 || this.sharedData.get("roles")[0].id == 2 )
         {
           //this.WpProviders = this.tasksVO.providerList;
         }
         else
         {
           this.WpProviders = this.tasksVO.providerList;
          }
        //this.countyList = this.tasksVO.countyList;
        document.getElementById("all").removeAttribute("hidden");
        /*document.getElementById("INP").setAttribute("hidden", "true");
        document.getElementById("pending").setAttribute("hidden", "true");
        document.getElementById("open").setAttribute("hidden", "true");*/

      }, response => {
        this.notificationService.error('Report Summary', this.userActionNotificationsMap.ERROR);
      }, () => {
        zingchart.render({
          id: 'reportSummary',
          data: this.chartData,
          height: 300,
          width: "100%"
        });
        zingchart.render({
          id: 'taskSummary',
          data: this.chartData2,
          height: 300,
          width: "100%"
        });
        const that = this;
        zingchart.node_click = function (e) {
          if(e.id === "reportSummary"){
            switch (e.plotindex) {
              case 0:
                this.pdfFlag = "content";
                console.log(this.pdfFlag);
                this.selectedGrid = 'IP';
                document.getElementById("all").removeAttribute("hidden");
                that.gridApi.setRowData(that.inProgressTasks);
                //document.getElementById("INP").setAttribute("hidden", "true");
                //document.getElementById("pending").setAttribute("hidden", "true");
                //document.getElementById("open").setAttribute("hidden", "true");
                that.tasks = that.inProgressTasks;
                break;
              case 1:
                this.pdfFlag = "content";
                console.log(this.pdfFlag);
                this.selectedGrid = 'OP';
                document.getElementById("all").removeAttribute("hidden");
                that.gridApi.setRowData(that.openTasks);
                /*document.getElementById("INP").setAttribute("hidden", "true");
                document.getElementById("pending").setAttribute("hidden", "true");
                document.getElementById("open").setAttribute("hidden", "true");*/
                that.tasks = that.openTasks;
                break;
              case 2:
                this.pdfFlag = "content";
                console.log(this.pdfFlag);
                this.selectedGrid = 'PE';
                document.getElementById("all").removeAttribute("hidden");
                that.gridApi.setRowData(that.pendingTasks);
                /*document.getElementById("INP").setAttribute("hidden", "true");
                document.getElementById("pending").setAttribute("hidden", "true");
                document.getElementById("open").setAttribute("hidden", "true");*/
                that.tasks = that.pendingTasks;
                break;
                case 3:
                this.pdfFlag = "content";
                console.log(this.pdfFlag);
                this.selectedGrid = 'OD';
                document.getElementById("all").removeAttribute("hidden");
                that.gridApi.setRowData(that.overDue);
                /*document.getElementById("INP").setAttribute("hidden", "true");
                document.getElementById("pending").setAttribute("hidden", "true");
                document.getElementById("open").setAttribute("hidden", "true");*/
                that.tasks = that.overDue;
                break;
            }
          }
          else{
                //this.pdfFlag = "content";
                //console.log(this.pdfFlag);
                this.selectedGrid = 'all';
                let filteredData=[];
                that.tasks.forEach((element)=>{
                  if(element.taskType.replace(/(\r\n|\n|\r)/gm, " ") === that.chartData2.graphset[0].series[e.plotindex]['text']){
                    filteredData.push(element);
                  }
                })
                that.tasks = filteredData;
                document.getElementById("all").removeAttribute("hidden");
                that.gridApi.setRowData(filteredData);
                /*document.getElementById("INP").setAttribute("hidden", "true");
                document.getElementById("pending").setAttribute("hidden", "true");
                document.getElementById("open").setAttribute("hidden", "true");*/
          }

        };
      });
    },0);

  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dateUtil: DateUtility,
    private http: HttpClient,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private refTableService: ReferenceTableService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
  }

  ngOnInit() {
    if (this.dataService.getSharedDataObject().get("RPRDE").navigation === false && this.dataService.getSharedDataObject().get("RPRDO").navigation === false) {
      this.router.navigate(['/reports/federalReports']);
    }
    this.inputTasksVO = new TasksVO();
    console.log(this.refTableService.getValueFromSharedDataMap('COUNTIES'));
    //console.log(this.refTableService.getValueFromSharedDataMap('AREA I'));
    //this.area1 = this.refTableService.getValueFromSharedDataMap('AREA I');
    this.area1 = this.refTableService.getValueFromSharedDataMap('AREA I');
    this.area1.shift();
    //console.log(this.area1);
    this.area2 = this.refTableService.getValueFromSharedDataMap('AREA II');
    this.area2.shift();
    this.area3 = this.refTableService.getValueFromSharedDataMap('AREA III');
    this.area3.shift();
    this.area4 = this.refTableService.getValueFromSharedDataMap('AREA IV');
    this.area4.shift();
    this.area5 = this.refTableService.getValueFromSharedDataMap('AREA V');
    this.area5.shift();
    this.area6 = this.refTableService.getValueFromSharedDataMap('AREA VI');
    this.area6.shift();
    this.allArea = this.refTableService.getValueFromSharedDataMap('COUNTIES');
    this.allArea.shift();
    this.countyList = this.allArea;
    /*this.area1 = this.refTableService.getValueFromSharedDataMap('AREA I');
    this.area2 = this.refTableService.getValueFromSharedDataMap('AREA II');
    this.area3 = this.refTableService.getValueFromSharedDataMap('AREA III');
    this.area4 = this.refTableService.getValueFromSharedDataMap('AREA IV');
    this.area5 = this.refTableService.getValueFromSharedDataMap('AREA V');
    this.area6 = this.refTableService.getValueFromSharedDataMap('AREA VI');
    this.allArea = this.refTableService.getValueFromSharedDataMap('COUNTIES');
    this.countyList = this.refTableService.getValueFromSharedDataMap('COUNTIES');*/
    if (this.reportBeginDate != null) {
      let day = this.reportBeginDate.day;
      let month = this.reportBeginDate.month;
      let year = this.reportBeginDate.year;
      if (day < 10 && month < 10) {
        this.reportBeginDate = year + '/0' + month + '/0' + day;
      }
      if (day < 10) {
        this.reportBeginDate = year + '/' + month + '/0' + day;
      }
      if (month < 10) {
        this.reportBeginDate = year + '/0' + month + '/' + day;
      }
      else {
        this.reportBeginDate = year + '/' + month + '/' + day;
      }
      console.log(this.reportBeginDate);
    }

    if (this.reportEndDate != null) {
      let day = this.reportEndDate.day;
      let month = this.reportEndDate.month;
      let year = this.reportEndDate.year;
      this.reportEndDate = year + '/' + month + '/' + day;

      if (day < 10 && month < 10) {
        this.reportEndDate = year + '/0' + month + '/0' + day;
      }
      if (day < 10) {
        this.reportEndDate = year + '/' + month + '/0' + day;
      }
      if (month < 10) {
        this.reportEndDate = year + '/0' + month + '/' + day;
      }
      else {
        this.reportEndDate = year + '/' + month + '/' + day;
      }
    }
    this.inputTasksVO.provider = "All";
    this.inputTasksVO.county = "All";
    this.inputTasksVO.taskType = "All";
    this.inputTasksVO.areaCode = "All";
    this.inputTasksVO.reportBeginDate = "default";
    this.inputTasksVO.reportEndDate = "default";
    this.sharedData = this.dataService.getSharedDataObject();
    this.roleId = this.sharedData.get("roles")[0].id;

    if (this.sharedData.get("roles")[0].id == 5) {
      this.butDisabled = true;
      console.log("counties : " + this.sharedData.get("userCounties").length);
      for (let i = 0; i < this.sharedData.get("userCounties").length; i++) {
        this.countyArray[i] = this.sharedData.get("userCounties")[i].id.serviceCounty;
        this.inputTasksVO.user = "provider";
        console.log("county id is : " + this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
      }
      this.inputTasksVO.countyArray = this.countyArray;
      this.inputTasksVO.providerId = this.sharedData.get("providerId");
    }
    else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
    {
    this.butDisabled = true;
    this.countyDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    console.log("county id is : "+this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
     }
    this.inputTasksVO.user = "countyWorker";
    this.inputTasksVO.countyArray=this.countyArray;
    this.inputTasksVO.county=this.countyArray[0];
    this.inputTasksVO.provider=null;
    this.inputTasksVO.areaCode=null;
    }
    else if(this.sharedData.get("roles")[0].id == 2)
    {
    this.butDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyId=this.sharedData.get("userCounties")[i].id.serviceCounty;
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    }
    this.inputTasksVO.countyArray=this.countyArray;
    this.inputTasksVO.user="areaSupervisor";
    this.inputTasksVO.county="All"
    this.inputTasksVO.areaCode = null;
    this.inputTasksVO.provider = null;
    }
    else {
      this.inputTasksVO.areaCode = "All";
      this.inputTasksVO.user = "countyUser";
    }
    //Retrieve reference tables
    this.refTableService.currentMessage.subscribe((message) => {
      //Parse reference table data
      if (message && message.englishDropDown) {
        this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(message.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
      }

      //Call load
      this.load();
    });
    this.getTasksColumnDefs();
    /* this.getInProgressColumnDefs();
     this.getOpenTasksColumnDefs();
     this.getPendingTasksColumnDefs();*/
  }

  getTasksColumnDefs() {
    this.tasksColumnDefs = [
      {
        headerName: 'Client ID',
        field: 'wpPersonId',
        cellRenderer: this.getPersonIdLink,
        tooltipField: 'wpPersonId'
      },
      {
        headerName: 'Task Type',
        field: 'taskType',
        cellRenderer: this.getTaskTypeLink,
        tooltipField: 'taskType'
      },
      {
        headerName: 'Client Name',
        field: 'assignedTo',
        tooltipField: 'assignedTo'
      },
      {
        headerName: 'Task Creation Date',
        field: 'taskStartDt',
        tooltipField: 'taskStartDt'
      },
      {
        headerName: 'Task Due Date',
        field: 'taskDueDt',
        tooltipField: 'taskDueDt'
      },
      {
        headerName: 'Service County',
        field: 'programCd',
        tooltipField: 'programCd'
      },
      {
        headerName: 'Task Completion Date',
        field: 'taskCompletionDt',
        tooltipField: 'taskCompletionDt'
      },
      {
        headerName: 'Task Status',
        field: 'taskStatus',
        tooltipField: 'taskStatus'
      },
      {
        headerName: 'Overdue',
        field: '',
        cellRenderer: this.isTaskOverDue
      },
      {
        headerName: 'Assigned To',
        field: 'assignedUserStr',
        tooltipField: 'assignedUserStr'
      }
    ];

    this.context = {
      component: this
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  /*onGridReadyProgress(params) {
    this.gridApiProgress = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onGridReadyOpen(params) {
    this.gridApiOpen = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onGridReadyPending(params) {
    this.gridApiPending = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }*/
  getPersonIdLink(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    element.innerHTML = params.data.wpPersonId;
    element.addEventListener('click', () => {
      that.routeSelection(params.data, params.data.wpPersonId,"Y"); 
      //that.goToEnrollmentSummary(params.data);
      /*const person = new WpPerson();
      const referral = new WpReferral();
      const indvTask = new Task();
      let taskSearch1 = new TaskSearch();

      person.id = params.data.wpPersonId;
      referral.id = that.referralId;
    indvTask.wpPerson = person;
    indvTask.wpReferral = referral;
    taskSearch1.task = indvTask;
    that.dataService.addValueToSharedDataMap("taskSearch", taskSearch1);*/
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.routeSelection(params.data, params.data.wpPersonId,"Y"); 
        //that.goToEnrollmentSummary(params.data);
        /*const person = new WpPerson();
      const referral = new WpReferral();
      const indvTask = new Task();
      let taskSearch1 = new TaskSearch();

      person.id = params.data.personId;
      referral.id = params.data.referralId;
    indvTask.wpPerson = person;
    indvTask.wpReferral = referral;
    taskSearch1.task = indvTask;
    that.dataService.addValueToSharedDataMap("taskSearch", taskSearch1);*/
      }
    });
    element.setAttribute('tabindex', '0');
    return element;
  }
  goToEnrollmentSummary(personId, referralId) {
    //this.setInitSearchCriteria();
    this.dataService.addValueToSharedDataMap('referralId', referralId);
    this.dataService.addValueToSharedDataMap('wpPersonId',personId.wpPersonId); 
    /*if (result.ssn !== undefined && result.ssn.length === 9) {
      this.dataService.addValueToSharedDataMap('SSN_SEARCH', result.ssn);
    }*/

    this.http.post<any>(this.ServerConstants.COMMON_SERVER_API_URL + '/personsummary/personEnrollmentSummary',
      { 'referralId': Number(referralId), 'personId': Number(personId.wpPersonId) })
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res === null || res === undefined) {
            this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          } else {
            const personEnrollmentSummary: any = res;

            if (personEnrollmentSummary.etEnrollment !== null) {
              if (personEnrollmentSummary.etEnrollment.enrollmentEndDt != null) {
                this.dataService.makeAllPagesReadyIfCaseClosed();
              } else {
                this.dataService.revertReadOnlyChanges();
                this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
              }
              this.dataService.addValueToSharedDataMap('etEnrollment', personEnrollmentSummary.etEnrollment);
            }
            if (personEnrollmentSummary.personProvider !== null) {
              this.dataService.addValueToSharedDataMap('personProvider', personEnrollmentSummary.personProvider);
              this.dataService.addValueToSharedDataMap('SSN_SEARCH', personEnrollmentSummary.personProvider.id.person.ssn);
              //this.sharedData.get('SSN_SEARCH');
            }
            this.router.navigate(['/task/personSummary']);
          }
        },
        response => {
          this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }


  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridOptions.columnDefs = this.tasksColumnDefs;
    }
    else {
      this.gridOptions.api.sizeColumnsToFit();
    }
  }
  getTaskTypeLink(params) {
    const that = params.context.component;
    //const taskTypeName = that.convertCode(that.taskTypesMap, params.data.taskType);

    if (params.data.taskStatus === 'Completed') {
      const element = document.createElement('div');
      element.innerHTML = params.data.taskType;
      element.setAttribute('tabindex', '0');
      return element;

    } else {
      const element = document.createElement('a');
      element.innerHTML = params.data.taskType;
      element.addEventListener('click', () => {
        //that.updateTaskStatus(params.data);
        that.routeSelection(params.data,params.data.wpPersonId,"N");
      });

      // START ADA
      element.addEventListener('keydown', (event) => {
        if (event.keyCode === 13 || event.keyCode === 32) {
          //that.updateTaskStatus(params.data);
          that.routeSelection(params.data,params.data.wpPersonId,"N");
        } else {
          return;
        }
      });
      element.setAttribute('tabindex', '0');
      // END ADA
      return element;
    }
  }
  
  routeSelection(task, wpPersonId, type) {
    this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/tasks/getTaskById', task.id).subscribe(
      (data: any) => {
        if (data == null || data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Task', "Task doesn't exist");
        } else {
          this.referralId = data.wpReferral.id;
          if(type === "Y"){
            this.goToEnrollmentSummary(task,this.referralId)
          }
          else{
            this.personDetails(task,wpPersonId);
          }
        }
      },
      response => {
        this.notificationService.error('Task', 'Error while geting the task');
      },
      () => {
      });
    }
    public personDetails(task,wpPersonId){
    //this.setInitSearchCriteria();
    this.dataService.addValueToSharedDataMap('referralId', this.referralId);
    this.dataService.addValueToSharedDataMap('wpPersonId', wpPersonId);
    if (task.taskType.replace(/(\r\n|\n|\r)/gm, " ") === 'Reverse Referral') {

      this.http.post<WpPerson>(this.ServerConstants.COMMON_SERVER_API_URL + '/persondata/load', wpPersonId).subscribe(
        (data: WpPerson) => {
          if (data !== undefined && data.ssn !== undefined) {
            this.dataService.addValueToSharedDataMap('SSN_SEARCH', data.ssn);
            this.dataService.addValueToSharedDataMap('UNIVERSE_SEARCH', true);
            this.navigateRoute(task);
          }

        }, response => {
          //Display Toast Error Notification
          this.notificationService.error('Person', this.userActionNotificationsMap.ERROR);
        }, () => {
        });
    } else {
      this.http.post<any>(this.ServerConstants.COMMON_SERVER_API_URL + '/personsummary/personEnrollmentSummary',
        { 'referralId': Number(this.referralId), 'personId': Number(wpPersonId) })
        .subscribe(
          (res: HttpResponse<any>) => {
            if (res === null || res === undefined) {
              this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
            } else {
              const personEnrollmentSummary: any = res;

              if (personEnrollmentSummary.etEnrollment !== null) {
                if (personEnrollmentSummary.etEnrollment.enrollmentEndDt != null) {
                  this.dataService.makeAllPagesReadyIfCaseClosed();
                } else {
                  this.dataService.revertReadOnlyChanges();
                  this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
                }
                this.dataService.addValueToSharedDataMap('etEnrollment', personEnrollmentSummary.etEnrollment);
              }
              if (personEnrollmentSummary.personProvider !== null) {
                this.dataService.addValueToSharedDataMap('personProvider', personEnrollmentSummary.personProvider);
              }
              this.navigateRoute(task);
            }
          },
          response => {
            this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          },
          () => {
          });
    }
  }

  navigateRoute(task) {
    console.log(task.taskType);
    switch (task.taskType) {
      case 'Referral (Actionable)': {  // Referral
        this.router.navigate(['task/contactSummary']);
        break;
      }
      case 'Appointment (Actionable)':
      case 'Citizen Appointment Request': {  // Referral
        this.dataService.addValueToSharedDataMap('appTaskId', task.id);
        this.router.navigate(['/task/appointment']);
        break;
      }
      case 'Perform Assessment (Actionable)': {  // Perform Assessment
        this.router.navigate(['task/assessmentSummary']);
        break;
      }
      case 'Client No Longer RTW (Actionable)':  // Client Not Longer RTW
      case 'Case Closure (Actionable)':  // Case Closure
      case 'Client Dropped From SNAP Case (Actionable)':  // Client Dropped from SNAP Case
      case 'Employment Plan Annual Review (Actionable)':  // Employment Plan Annual Review
      case 'Employment Plan (Actionable)': {  // Employment Plan
        this.dataService.addValueToSharedDataMap('taskId', task.id);
        this.router.navigate(['task/employmentPlanSummary']);
        break;
      }
      case 'Component (Actionable)':  // Component
      case 'Component Updates': {  // Component Updates
        this.router.navigate(['task/componentSummary']);
        break;
      }
      case 'Monthly Track Component (Actionable)':
      case 'Citizen Hours Approval':
      case 'Citizen Comparable Workfare Approval': {  // Monthly Track Component
        this.router.navigate(['task/componentSummary/trackComponent']);

        break;
      }
      case 'Provider Reassignment (Actionable)': {  // Provider Reassigment
        this.router.navigate(['task/personSummary/enrollmentSummary']);
        break;
      }
      case 'Exemption Request (Actionable)':
      case 'Citizen Exemption Request':
      case 'Citizen Good Cause Request':
      case 'Citizen Good Cause Requested':
      case 'Citizen Good Cause Decision':
      case 'Non-Compliance (Actionable)':  // Non Compliance
      case 'Non-Compliance Decision (Informational)':
      case 'Good Cause Request (Actionable)':  // Good Cause Request
      case 'Good Cause Decision (Informational)': {  // Good Cause Decision
        this.router.navigate(['/task/noncomplianceSummary']);
        break;
      }
      case 'Exemption Decision (Informational)': {  // Exemption Decision
        this.router.navigate(['/task/noncomplianceSummary']);
        break;
      }
      /*case 'PR': {  // Provider Reassignment
        this.router.navigate(['task/personSummary']);
        break;
      }*/
      case 'Work Registration Exemption Request':  // Work Registration Exemption
      case 'Non-Compliance Decision':  // Non Compliance Decision
      case 'Exemption Request':  // Exemption Request
      case 'Reverse Referral': {  // Reverse Referral
        this.dataService.addValueToSharedDataMap('task', task);
        this.router.navigate(['/universe/create']);
        break;
      }
      case 'Address Change (Actionable)':  // Address Change
      case 'Fair Hearing Request':
      case 'Citizen Document Upload':
      case 'E & T Participation':
      case 'Other': {  // Reverse Referral
        this.dataService.addValueToSharedDataMap('task', task);
        this.router.navigate(['/task/createTask']);
        break;
      }
      case 'Reimbursement Request (Actionable)':  // Reimbursement Request
      case 'Reimbursement Decision (Informational)':
      case 'Reimbursement Authorized':  //  Reimbursement Decision
      case 'Reimbursement Return for Revision (Actionable)': {  //  Reimbursement Return for Revision (Actionable)
        this.router.navigate(['/task/reimbursementsSummary']);
        break;
      }
      case 'Reverse Referral (Actionable)': {  // Reverse Referral
        this.router.navigate(['/universe/personSummary']);
        break;
      }
      case 'Employment Change': {  // Employment Change
        this.router.navigate(['task/assessmentSummary']);
        break;
      }
      case 'Contact Changes (Actionable)': {  // Contact Change
        this.router.navigate(['task/personSummary']);
        break;
      }
    }
  }
  isTaskOverDue(params) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateParts = params.data.taskDueDt.split('/');
    const year = Number(dateParts[2]);
    const day = Number(dateParts[1]);
    const month = Number(dateParts[0]) - 1;
    const taskDueDt = new Date(year, month, day);
    const icon = OVERDUE_BTN;
    let element = null;

    if (params.data.taskStatus !== 'Completed' && today > taskDueDt) {
      element = document.createElement('span');
      element.innerHTML = icon;
      return element;
    } else {
      return null;
    }
  }

  searchTask() {
    this.overDue = [];
    this.inputTasksVO = new TasksVO();
    this.inputTasksVO.provider = this.provider;
    this.inputTasksVO.county = this.county;
    this.inputTasksVO.areaCode = this.areaCode;

    if (this.reportBeginDate != null) {
      let day = this.reportBeginDate.day;
      let month = this.reportBeginDate.month;
      let year = this.reportBeginDate.year;
      if (day < 10 && month < 10) {
        this.reportBeginDate = year + '/0' + month + '/0' + day;
      }
      else if (day < 10) {
        this.reportBeginDate = year + '/' + month + '/0' + day;
      }
      else if (month < 10) {
        this.reportBeginDate = year + '/0' + month + '/' + day;
      }
      else {
        this.reportBeginDate = year + '/' + month + '/' + day;
      }
    }
    console.log(this.reportBeginDate);


    if (this.reportEndDate != null) {
      let day = this.reportEndDate.day;
      let month = this.reportEndDate.month;
      let year = this.reportEndDate.year;
      this.reportEndDate = year + '/' + month + '/' + day;

      if (day < 10 && month < 10) {
        this.reportEndDate = year + '/0' + month + '/0' + day;
      }
      else if (day < 10) {
        this.reportEndDate = year + '/' + month + '/0' + day;
      }
      else if (month < 10) {
        this.reportEndDate = year + '/0' + month + '/' + day;
      }
      else {
        this.reportEndDate = year + '/' + month + '/' + day;
      }
    }

    if (this.sharedData.get("roles")[0].id == 5) {
      this.butDisabled = true;
      console.log("counties : " + this.sharedData.get("userCounties").length);
      for (let i = 0; i < this.sharedData.get("userCounties").length; i++) {
        this.countyArray[i] = this.sharedData.get("userCounties")[i].id.serviceCounty;
        console.log("county id is : " + this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
      }
      this.inputTasksVO.countyArray = this.countyArray;
      this.inputTasksVO.user = "provider";
      this.inputTasksVO.providerId = this.sharedData.get("providerId");
    }
    else if(this.sharedData.get("roles")[0].id == 1 || this.sharedData.get("roles")[0].id == 3)
    {
    this.butDisabled = true;
    this.countyDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    console.log("county id is : "+this.sharedData.get("userCounties")[i].id.serviceCounty); //use i instead of 0
     }
    this.inputTasksVO.user = "countyWorker";
    this.inputTasksVO.countyArray=this.countyArray;
    this.inputTasksVO.county=this.county;
    this.inputTasksVO.provider=null;
    this.inputTasksVO.areaCode=null;
    }
    else if(this.sharedData.get("roles")[0].id == 2)
    {
    this.butDisabled = true;
    for(let i=0; i<this.sharedData.get("userCounties").length; i++){
    this.countyId=this.sharedData.get("userCounties")[i].id.serviceCounty;
    this.countyArray[i]=this.sharedData.get("userCounties")[i].id.serviceCounty;
    }
    this.inputTasksVO.countyArray=this.countyArray;
    this.inputTasksVO.user="areaSupervisor";
    this.inputTasksVO.county=this.county;
    this.inputTasksVO.areaCode = this.areaCode;
    this.inputTasksVO.provider = null;
    }
    else {
      this.inputTasksVO.areaCode = this.areaCode;
      this.inputTasksVO.user = "countyUser";
    }
    this.inputTasksVO.taskType = this.tasktype;
    this.inputTasksVO.reportBeginDate = this.reportBeginDate;
    this.inputTasksVO.reportEndDate = this.reportEndDate;
    this.load();
  }

  validDates() {
    if (this.reportBeginDate !== undefined
      && this.reportBeginDate !== null
      && this.reportEndDate !== undefined
      && this.reportEndDate !== null) {
      const startDt = new Date(this.reportBeginDate.year,
        this.reportBeginDate.month - 1,
        this.reportBeginDate.day);
      const endDt = new Date(this.reportEndDate.year,
        this.reportEndDate.month - 1,
        this.reportEndDate.day)

      if (startDt > endDt) {
        this.errorEndDateField = REPSTDT_GT_REPENDDT;
        return false;
      } else {
        this.errorEndDateField = null;
      }
    }

    return true;
  }

  ngAfterViewInit() {

  }

  focusSummary(e) {
    this.firstTime = false;
    this.addEventListenerToButton(e);
  }

  addEventListenerToButton(event) {
    const tabKeyCode = 9;
    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }
    // set focus on the first cell in the ag-grid
    const inpE = document.getElementById('INP');
    const openE = document.getElementById('open');
    const pendingE = document.getElementById('pending');
    const allE =  document.getElementById('all');

    if ( !allE.hasAttribute('hidden') ) {
      /*if (this.tasks.length === 0) {
        this.addOnAgGridForAda(allE);
      } else {*/
        this.setDisplayedRowAtIndex();

    } else if ( !openE.hasAttribute('hidden') ) {
      /*if (this.openTasks.length === 0) {
        this.addOnAgGridForAda(openE);
      } else {*/
        this.setDisplayedRowAtIndexOpen();

    } else if ( !inpE.hasAttribute('hidden') ) {
      /*if (this.inProgressTasks.length === 0) {
        this.addOnAgGridForAda(inpE);
      } else {*/
        this.setDisplayedRowAtIndexProgress();

    } else if ( !pendingE.hasAttribute('hidden') ) {
      /*if (this.pendingTasks.length === 0) {
        this.addOnAgGridForAda(pendingE);
      } else {*/
        this.setDisplayedRowAtIndexPending();

    }
  }

  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  setDisplayedRowAtIndexOpen() {
    // get the first row
    const index = this.gridApiOpen.getFirstDisplayedRow();
    const rowNode = this.gridApiOpen.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApiOpen.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApiOpen.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApiOpen.setFocusedCell(index, firstCol);
  }

  setDisplayedRowAtIndexProgress() {
    // get the first row
    const index = this.gridApiProgress.getFirstDisplayedRow();
    const rowNode = this.gridApiProgress.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApiProgress.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApiProgress.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApiProgress.setFocusedCell(index, firstCol);
  }

  setDisplayedRowAtIndexPending() {
    // get the first row
    const index = this.gridApiPending.getFirstDisplayedRow();
    const rowNode = this.gridApiPending.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApiPending.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApiPending.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApiPending.setFocusedCell(index, firstCol);
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      const inpE = document.getElementById('INP');
      const openE = document.getElementById('open');
      const pendingE = document.getElementById('pending');
      const allE =  document.getElementById('all');

     
        this.setDisplayedRowAtIndex();
      
    }
  }

  gridClick() {
    this.firstTime = false;
  }

  addOnAgGridForAda( element) {
    if (element) {
      if ((element as HTMLDivElement).hasAttribute('tabIndex')) {
        (element as HTMLDivElement).removeAttribute('tabIndex');
      }

      if ((element as HTMLDivElement).hasAttribute('role')) {
        (element as HTMLDivElement).removeAttribute('role');
      }

      if ((element as HTMLDivElement).hasAttribute('aria-labeledby')) {
        (element as HTMLDivElement).removeAttribute('aria-labeledby');
      }

     // Empty Ag-Grid
        (element as HTMLDivElement).setAttribute('tabIndex', Number(0).toString());
        (element as HTMLDivElement).setAttribute('role', 'textbox');
        (element as HTMLDivElement).setAttribute('aria-labeledby', 'agGridNotDataFoundDiv');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/report-summary/report-summary.component.ts